import { render, staticRenderFns } from "./FormgiftCode.vue?vue&type=template&id=26b3e0d3&scoped=true&"
import script from "./FormgiftCode.vue?vue&type=script&lang=js&"
export * from "./FormgiftCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b3e0d3",
  null
  
)

export default component.exports